(function () {
  'use strict';
  var KEY = 'loom_wishlist';
  var HEART_FULL = '<svg viewBox="0 0 24 24" width="22" height="22" fill="#111"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
  var HEART_EMPTY = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#111" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

  var WL = {
    get: function () { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } },
    has: function (h) { return !!this.get()[h]; },
    toggle: function (h, data) {
      var list = this.get();
      if (list[h]) { delete list[h]; } else { list[h] = data; }
      localStorage.setItem(KEY, JSON.stringify(list));
      return !!list[h];
    },
    count: function () { return Object.keys(this.get()).length; }
  };

  function updateHeaderCount() {
    var count = WL.count();
    var badge = document.querySelector('.loom-wishlist-count');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  function initHearts() {
    document.querySelectorAll('.block.product').forEach(function (card) {
      if (card.querySelector('.loom-wl-btn')) return;
      var link = card.querySelector('a.img-link');
      if (!link) return;
      var url = link.getAttribute('href') || '';
      var m = url.match(/\/products\/([^?#\/]+)/);
      if (!m) return;
      var handle = m[1];
      var title = link.getAttribute('title') || '';
      var img = card.querySelector('img');
      var imgSrc = img ? (img.getAttribute('data-src') || img.getAttribute('src') || '') : '';
      var main = card.querySelector('.main');
      if (!main) return;

      var btn = document.createElement('button');
      btn.className = 'loom-wl-btn' + (WL.has(handle) ? ' active' : '');
      btn.setAttribute('type', 'button');
      btn.setAttribute('aria-label', 'Guardar en favoritos');
      btn.innerHTML = WL.has(handle) ? HEART_FULL : HEART_EMPTY;

      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var active = WL.toggle(handle, { title: title, img: imgSrc, url: url });
        btn.className = 'loom-wl-btn' + (active ? ' active' : '');
        btn.innerHTML = active ? HEART_FULL : HEART_EMPTY;
        updateHeaderCount();
        btn.classList.add('loom-wl-pop');
        setTimeout(function () { btn.classList.remove('loom-wl-pop'); }, 300);
      });

      main.appendChild(btn);
    });
  }

  function renderWishlistPage() {
    var container = document.getElementById('loom-wishlist-page');
    if (!container) return;
    var items = WL.get();
    var handles = Object.keys(items);
    if (handles.length === 0) {
      container.innerHTML = '<div class="loom-wl-empty"><p>Tu lista de favoritos está vacía.</p><a href="/collections/all" class="button">Explorar productos</a></div>';
      return;
    }
    var grid = document.createElement('div');
    grid.className = 'loom-wl-grid';
    container.innerHTML = '';
    container.appendChild(grid);

    handles.forEach(function (handle) {
      var item = items[handle];
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var price = p.price_min ? (p.price_min / 100).toFixed(2).replace('.', ',') + ' €' : '';
          var imgSrc = p.featured_image || item.img || '';
          var card = document.createElement('div');
          card.className = 'loom-wl-card';
          card.innerHTML =
            '<a href="/products/' + p.handle + '" class="loom-wl-img-wrap"><img src="' + imgSrc + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy"></a>' +
            '<div class="loom-wl-info">' +
              '<a href="/products/' + p.handle + '" class="loom-wl-title">' + (p.title || item.title || '') + '</a>' +
              (price ? '<p class="loom-wl-price">' + price + '</p>' : '') +
              '<div class="loom-wl-actions">' +
                '<a href="/products/' + p.handle + '" class="button">Ver producto</a>' +
                '<button class="loom-wl-remove" data-handle="' + handle + '" aria-label="Quitar">&#10005;</button>' +
              '</div>' +
            '</div>';
          card.querySelector('.loom-wl-remove').addEventListener('click', function () {
            WL.toggle(handle, null);
            card.remove();
            updateHeaderCount();
            if (grid.children.length === 0) {
              container.innerHTML = '<div class="loom-wl-empty"><p>Tu lista de favoritos está vacía.</p><a href="/collections/all" class="button">Explorar productos</a></div>';
            }
          });
          grid.appendChild(card);
        })
        .catch(function () { WL.toggle(handle, null); });
    });
  }

  var _observer;
  function init() {
    updateHeaderCount();
    initHearts();
    renderWishlistPage();
    if (!_observer) {
      _observer = new MutationObserver(function () { initHearts(); });
      _observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.LoomWishlist = WL;
})();

/* ================================================================
   LOOM · Quick buy (boton ANADIR AL CARRITO de las fichas de rejilla)
   Antes esto se escribia una vez por producto dentro de
   snippets/product-block.liquid (50 copias por pagina, ~209 KB).
   Ahora vive aqui y se carga una sola vez. 12-sep-2026.
   ================================================================ */
(function(){
  function updateCartBadge(count){
    document.querySelectorAll('.numitems').forEach(function(el){
      el.textContent='('+count+')';
    });
  }

  function cartAdd(variantId,onDone){
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:parseInt(variantId),quantity:1})
    })
    .then(function(r){return r.json();})
    .then(function(){
      return fetch('/cart.js').then(function(r){return r.json();});
    })
    .then(function(cart){
      updateCartBadge(cart.item_count);
      if(onDone) onDone(true);
    })
    .catch(function(){
      if(onDone) onDone(false);
    });
  }

  function cartRemoveOne(variantId,onDone){
    fetch('/cart.js')
    .then(function(r){return r.json();})
    .then(function(cart){
      var item=cart.items.find(function(i){return String(i.id)===String(variantId);});
      if(!item){if(onDone) onDone(true);return cart;}
      var newQty=Math.max(0,item.quantity-1);
      return fetch('/cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:item.key,quantity:newQty})
      }).then(function(r){return r.json();});
    })
    .then(function(cart){
      if(cart && typeof cart.item_count!=='undefined') updateCartBadge(cart.item_count);
      if(onDone) onDone(true);
    })
    .catch(function(){
      if(onDone) onDone(false);
    });
  }

  function flash(numEl){
    numEl.classList.add('qb-added');
    setTimeout(function(){numEl.classList.remove('qb-added');},400);
  }

  function toggleAddState(wrap,cur){
    var addBtn=wrap.querySelector('.qb-add-btn');
    var qtyWrap=wrap.querySelector('.qb-qty-wrap');
    if(cur<=0){
      if(addBtn) addBtn.style.display='';
      if(qtyWrap) qtyWrap.style.display='none';
    } else {
      if(addBtn) addBtn.style.display='none';
      if(qtyWrap) qtyWrap.style.display='';
    }
  }

  function initQB(){
    document.querySelectorAll('.qb-add-btn').forEach(function(btn){
      if(btn.dataset.qbInit) return;
      btn.dataset.qbInit='1';
      btn.addEventListener('click',function(e){
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var wrap=btn.closest('.quick-buy-form');
        var variantId=wrap.dataset.variantId;
        var v=wrap.querySelector('.qb-qty-val');
        var n=wrap.querySelector('.qb-qty-num');
        btn.disabled=true;
        cartAdd(variantId,function(ok){
          btn.disabled=false;
          if(ok){
            v.value=1;n.textContent=1;
            toggleAddState(wrap,1);
            flash(n);
          }
        });
      });
    });
    document.querySelectorAll('.qb-qty-btn').forEach(function(btn){
      if(btn.dataset.qbInit) return;
      btn.dataset.qbInit='1';
      btn.addEventListener('click',function(e){
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var wrap=btn.closest('.quick-buy-form');
        var variantId=wrap.dataset.variantId;
        var v=wrap.querySelector('.qb-qty-val');
        var n=wrap.querySelector('.qb-qty-num');
        var cur=parseInt(v.value)||0;
        if(btn.classList.contains('qb-qty-plus')){
          cur++;v.value=cur;n.textContent=cur;
          btn.disabled=true;
          cartAdd(variantId,function(ok){
            btn.disabled=false;
            if(ok){flash(n);}
            else{cur--;v.value=cur;n.textContent=cur;}
            toggleAddState(wrap,cur);
          });
        } else if(cur>0){
          cur--;v.value=cur;n.textContent=cur;
          btn.disabled=true;
          cartRemoveOne(variantId,function(ok){
            btn.disabled=false;
            if(!ok){cur++;v.value=cur;n.textContent=cur;}
            toggleAddState(wrap,cur);
          });
        }
      });
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initQB);
  } else {
    initQB();
  }
  if(window.MutationObserver){
    new MutationObserver(function(){initQB();}).observe(document.body,{childList:true,subtree:true});
  }
})();